
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({})
export default class DashboardImage extends Vue {
	@Prop()
	value: any;

	@Prop()
	edit!: boolean

	imageUrl: string = "";
	imageLoaded: boolean = false;
	imageError: boolean = false;

	private get backgroundStyle () {
		return {
			background: this.imageLoaded ? `url(${this.imageUrl})` : "none"
		}
	}

	mounted () {
		if (this.value) {
			this.imageUrl = this.value
		}
	}

	@Watch("imageUrl")
	private updateImageUrl (value: any) {
		this.imageError = false
		this.imageLoaded = false

		this.$emit("input", value)
	}
}
